import { compile } from 'path-to-regexp'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { Redirect, Route } from 'react-router-dom'

class RedirectWithParams extends PureComponent {
  getRedirectComponent = ({ match, location }) => {
    const { push, to } = this.props
    const pathTo = compile(to)

    const toObject = {
      ...location,
      pathname: pathTo(match.params)
    }

    return <Redirect to={toObject} push={push} />
  }

  render() {
    const { exact, from } = this.props
    return (
      <Route
        exact={exact}
        path={from}
        component={this.getRedirectComponent}
      />
    )
  }
}

RedirectWithParams.propTypes = {
  from: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  exact: PropTypes.bool,
  push: PropTypes.bool
}

RedirectWithParams.defaultProps = {
  exact: false,
  push: false,
}

export default RedirectWithParams